import { EventTypes, type EventType } from 'types/types';
import { EVENT_TYPES } from 'variables';
import { PractitionerData, useGetCreateableEventTypes } from 'api';

export const useGetEventTypes = (
  practitioner?: PractitionerData,
): { status: any; eventTypes: Partial<EventTypes> } => {
  const { data: { eventTypes: eventTypesList } = { eventTypes: [] }, status } =
    useGetCreateableEventTypes(practitioner?.id ?? '', {});

  const eventTypes = eventTypesList.length
    ? Object.fromEntries(
        eventTypesList.map((type: EventType) => [type, EVENT_TYPES[type]]),
      )
    : {};
  return { status, eventTypes };
};

export default useGetEventTypes;
